import { useState, useEffect } from 'react';
import NewEditor from './newEditor';
import { ImagePlus } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import {
  useBlogPostMutation,
  useGetCategoryQuery,
  useGetAuthorQuery,
} from '../../reactWrapper/Redux/apiSlice';
import { toast } from 'react-toastify';

const FirstPage = () => {
  const [blogPost, { isLoading: isPosting, isSuccess, error }] =
    useBlogPostMutation();
  const {
    data: category,
    isLoading: loadingCat,
    isError: errCat,
    error: errCatMsg,
  } = useGetCategoryQuery();
  console.log('category data', category);
  const {
    data: authors,
    isLoading: loadingAut,
    isError: errAut,
    error: errAutMsg,
  } = useGetAuthorQuery();
  console.log('category data', authors);

  const history = useHistory();

  const [initialValue, setInitialValue] = useState(
    '<p> Type blog content here </p>'
  );

  const [title, setTitle] = useState('');
  const [category_id, setCategory_Id] = useState();
  const [contentEditor, setContentEditor] = useState(initialValue ?? '');
  const [featured_image_link, setFeatured_Image_Link] = useState(null);
  const [featured_image_links, setFeatured_Image_Links] = useState(null);
  const [authors_name, setAuthors_Name] = useState('');
  const [meta_description, setMeta_Description] = useState('');
  const [key_phrase, setKey_Phrase] = useState('');

  useEffect(() => {
    console.log('data', category);
    if (errCatMsg) {
      toast.error("Couldn't fetch category data");
    }
  }, [category, errCatMsg]);

  useEffect(() => {
    console.log('data', authors);
    if (errAutMsg) {
      toast.error("Couldn't fetch author's data");
    }
  }, [authors, errAutMsg]);

  useEffect(() => {
    if (error) {
      toast.error(error.message);
      console.log('first part', error);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    var formdata = new FormData();
    formdata.append('title', title);
    formdata.append('content', contentEditor);
    formdata.append('authors_name', authors_name);
    formdata.append('featured_image_link', featured_image_link);
    formdata.append('category_id', category_id);
    formdata.append('meta_description', meta_description);
    formdata.append('key_phrase', key_phrase);

    // await blogPost({ title, featured_image_link, content, blogPostCategories, authors_name, meta_description, key_phrase })

    try {
      await blogPost(formdata);
      setTitle('');
      setCategory_Id();
      setAuthors_Name('');
      setMeta_Description('');
      setKey_Phrase('');
      // console.log("this is d form data", ...formdata, contentEditor)
      // console.log("this is the content", contentEditor)
    } catch (error) {
      toast.error(error.data.message);
      console.error('Failed to save the post: ', error);
    }

    // await blogPost(formdata)
    // setTitle('')
    // setCategory_Id()
    // setAuthors_Name('')
    // setMeta_Description('')
    // setKey_Phrase('')
    // history.push('/mypost')
  };

    useEffect(() => {
        if(error) {
            toast.error(error.data.message)
            console.log("first part", error)
        }
    }, [error])

  const handleChange = (event) => {
    // if (event.target.files && event.target.files[0]) {
    setFeatured_Image_Links(URL.createObjectURL(event.target.files[0]));
    // console.log('this is the full image', featured_image_link)
    setFeatured_Image_Link(event.target.files[0]);
    console.log('this is the full image', featured_image_link);
    // }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className='rounded-2xl border bg-card p-6 shadow-ui-sm'
    >
      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
        {/* BLOG IMAGE — reference dropzone */}
        <div className='sm:col-span-2'>
          <span className='text-sm font-medium leading-none text-brand-navy'>
            Blog Image
          </span>
          <label
            htmlFor='featured_image'
            className='mt-1 flex cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-brand-navy/20 bg-surface py-12 transition-colors hover:border-brand-orange hover:bg-brand-orange-100/30'
          >
            <ImagePlus className='h-6 w-6 text-brand-navy' />
            <span className='mt-2 text-sm font-medium text-brand-navy'>
              Choose an image
            </span>
            <span className='mt-0.5 text-xs text-muted-foreground'>
              PNG or JPG
            </span>
            <input
              id='featured_image'
              type='file'
              className='sr-only'
              onChange={(e) => handleChange(e)}
            />
          </label>

          {featured_image_links && (
            <div className='mt-3 h-60 overflow-hidden rounded-xl border'>
              <img
                src={featured_image_links}
                alt='preview view'
                className='h-full w-full object-cover'
              />
            </div>
          )}
        </div>

        {/* TITLE */}
        <div className='sm:col-span-2'>
          <label
            htmlFor='title'
            className='text-sm font-medium leading-none text-brand-navy'
          >
            Title
          </label>
          <input
            type='text'
            className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
            name='title'
            id='title'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        {/* KEY PHRASES */}
        <div className='sm:col-span-2'>
          <label
            htmlFor='key_phrase'
            className='text-sm font-medium leading-none text-brand-navy'
          >
            Key Phrases
          </label>
          <input
            type='text'
            className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
            name='key_phrase'
            id='key_phrase'
            value={key_phrase}
            onChange={(e) => setKey_Phrase(e.target.value)}
            required
          />
        </div>

        {/* CATEGORY */}
        <div>
          <label
            htmlFor='category'
            className='text-sm font-medium leading-none text-brand-navy'
          >
            Choose Category
          </label>
          <select
            id='category'
            value={category_id}
            onChange={(e) => setCategory_Id(e.target.value)}
            className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm shadow-ui-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
            name='action'
          >
            <option>Select category</option>
            {category &&
              category.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
          </select>
          {/* the error block used to render INSIDE the <select>, which is invalid */}
          {errCat && (
            <div className='mt-2 flex items-start gap-2 rounded-lg bg-red-50 p-3 text-xs text-red-800'>
              {errCatMsg.toString()}
            </div>
          )}
        </div>

        {/* AUTHOR */}
        <div>
          <label
            htmlFor='author'
            className='text-sm font-medium leading-none text-brand-navy'
          >
            Select Author
          </label>
          <select
            id='author'
            value={authors_name}
            onChange={(e) => setAuthors_Name(e.target.value)}
            className='mt-1 flex h-9 w-full rounded-md border border-input bg-transparent px-3 text-sm shadow-ui-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
            name='action'
          >
            <option>{loadingAut ? 'Loading...' : 'Select Author'}</option>
            {authors &&
              authors.map((item) => <option key={item.id}>{item.name}</option>)}
          </select>
          {errAut && (
            <div className='mt-2 flex items-start gap-2 rounded-lg bg-red-50 p-3 text-xs text-red-800'>
              {errAutMsg.toString()}
            </div>
          )}
        </div>

        {/* META DESCRIPTION */}
        <div className='sm:col-span-2'>
          <label
            htmlFor='meta'
            className='text-sm font-medium leading-none text-brand-navy'
          >
            Meta Description
          </label>
          <textarea
            name='content'
            id='meta'
            rows={4}
            className='mt-1 flex w-full resize-none rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-ui-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
            value={meta_description}
            onChange={(e) => setMeta_Description(e.target.value)}
            required
          />
        </div>

        {/* CONTENT */}
        <div className='sm:col-span-2'>
          <span className='text-sm font-medium leading-none text-brand-navy'>
            Content
          </span>
          <div className='mt-1'>
            <NewEditor
              contentEditor={contentEditor}
              setContentEditor={setContentEditor}
              initialValue={initialValue}
              setInitialValue={setInitialValue}
            />
          </div>
        </div>
      </div>

      {/* FOOTER: helper control left, the one orange commit right */}
      <div className='mt-6 flex flex-col-reverse gap-3 border-t pt-4 sm:flex-row sm:items-center sm:justify-between'>
        <select
          className='h-9 rounded-md border border-input bg-transparent px-3 text-sm shadow-ui-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring sm:w-52'
          name='action'
        >
          <option>Save and Publish</option>
          <option>Save Draft</option>
        </select>

        <button
          type='submit'
          disabled={isPosting}
          className='inline-flex h-9 items-center justify-center rounded-lg bg-brand-orange px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-orange-600 disabled:pointer-events-none disabled:opacity-50'
        >
          {isPosting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </form>
  );
};

export default FirstPage;
